export default "__VITE_ASSET__2b_IrNAz__"